import React, { useEffect, useState } from 'react';

const SettingsText = ({ id, label, initialValue, defaultValue, onChange }) => {
  const [value, setValue] = useState('');
  const [timer, setTimer] = useState(null);

  const handleChange = ({ target }) => {
    const newValue = target.value;

    setValue(newValue);

    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }

    setTimer(
      setTimeout(() => {
        onChange(id, newValue);
      }, 1000),
    );
  };

  useEffect(() => {
    setValue(initialValue ?? defaultValue);
  }, [initialValue]);

  return (
    <div className="mb-4">
      <div className="paylixecommerce-label">
        {label}
      </div>

      <input className="paylixecommerce-input w-100" value={value} onChange={handleChange} />
    </div>
  );
};

export default SettingsText;
